import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider, useLocation } from "react-router-dom";
import { AppProviders } from "./lib/providers";
import { App } from "./App";
import { AmendmentDiffTool } from "./pages/AmendmentDiffTool";
import { RoutedAppErrorBoundary } from "./components/AppErrorBoundary";
import "./index.css";

const root = document.getElementById("root");
if (root === null) throw new Error("#root element not found");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <RouterProvider router={createBrowserRouter([{ path: "*", element: <Root /> }])} />
  </React.StrictMode>,
);

function Root() {
  const location = useLocation();
  const publicPath = location.pathname.replace(/\/+$/, "") || "/";
  if (publicPath === "/diff-tool") return <AmendmentDiffTool publicAccess />;

  return <RoutedAppErrorBoundary><AppProviders><App /></AppProviders></RoutedAppErrorBoundary>;
}
